export const dealWithBlank = obj => {
  for (var i in obj) {
    if (obj[i] && isString(obj[i])) {
      obj[i] = obj[i].replace(/^\s*|\s*$/g, '')
    }
  }
  return obj
}
export const isString = str => {
  return typeof str === 'string' && str.constructor === String
}



// WEBPACK FOOTER //
// ./src/components/forms/AddBusinessForm/enum.js